'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import FileUsage from '../FileUsage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { fetchFileUsage } from '../../actions/CosIndex';
import { getFileUsage, getFileUsageRequestStatus } from '../../selectors/FileUsage';
import { MODAL_WIDTH, RequestStatus } from 'FileManagerCore/Constants';
import { getHasFileUsageRequestFailedOrIsEmpty } from '../../utils/utils';
import { removeFile } from '../../actions/Files';
import { closeModal, selectFile } from '../../actions/Actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function handleModalClick(event) {
  event.stopPropagation();
}
class DeleteFileModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      deletePending: false
    };
    this.getI18nKey = suffix => `FileManagerCore.trashModal.${suffix}`;
    this.handleConfirm = () => {
      this.props.selectFile(null);
      this.setState({
        deletePending: true
      });
      this.props.removeFile(this.props.file);
      this.props.closeModal();
    };
  }
  componentDidMount() {
    const {
      file
    } = this.props;
    this.props.fetchFileUsage(file.get('id'));
  }
  isFileUsageLoading() {
    return this.props.fileUsageRequestStatus === RequestStatus.PENDING;
  }
  renderFileUsage() {
    const {
      fileUsage,
      fileUsageRequestStatus
    } = this.props;
    if (this.isFileUsageLoading()) {
      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerDashboard.fileUsage.loading"
        }),
        showLabel: true
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "m-top-3",
      "data-test-id": "delete-file-modal-usage",
      children: [!fileUsage.get('items').isEmpty() && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.trashModal.fileUsage"
      }), /*#__PURE__*/_jsx(FileUsage, {
        hasRequestFailed: getHasFileUsageRequestFailedOrIsEmpty(fileUsage, fileUsageRequestStatus),
        usage: fileUsage,
        forDeleteModal: true
      })]
    });
  }
  render() {
    const {
      file
    } = this.props;
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      onClick: handleModalClick,
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: this.getI18nKey('deleteFileConfirmLabel')
      }),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: this.getI18nKey('cancel')
      }),
      confirmUse: "danger",
      rejectUse: "tertiary-light",
      width: MODAL_WIDTH,
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: this.getI18nKey('deleteFileDescription'),
          options: {
            name: file.get('name')
          }
        }), this.renderFileUsage()]
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: this.getI18nKey('deleteFileMessage')
      }),
      use: "danger",
      disableConfirm: this.isFileUsageLoading() || this.state.deletePending,
      onConfirm: this.handleConfirm,
      onReject: this.props.closeModal,
      "data-test-id": "delete-file-modal"
    });
  }
}
DeleteFileModal.propTypes = {
  file: PropTypes.instanceOf(Immutable.Map).isRequired,
  fileUsage: PropTypes.instanceOf(Immutable.Map).isRequired,
  fileUsageRequestStatus: PropTypes.oneOf(Object.keys(RequestStatus)),
  fetchFileUsage: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectFile: PropTypes.func.isRequired
};
const mapStateToProps = (state, {
  file
}) => {
  return {
    fileUsage: getFileUsage(state, {
      file
    }),
    fileUsageRequestStatus: getFileUsageRequestStatus(state, {
      file
    })
  };
};
const mapDispatchToProps = {
  fetchFileUsage,
  removeFile,
  closeModal,
  selectFile
};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteFileModal);